import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Modal from 'react-modal'
import config from '../../config'
import {
  Link,
  LinkIcon
} from '../../components'
import Styles from './DonateModal.css'


@CSSModules(Styles,{allowMultiple:true})
export default class DonateModal extends Component {
  constructor(props){
    super(props);
    this.state = {
      modalOpen: false,
    }
  }

  componentDidMount() {
    setTimeout( () => {
      this.openModal()
    }, 1)
  }

  openModal = () =>{
    this.setState({ modalOpen: true })
  }

  closeModal = () =>{
    this.setState({ modalOpen: false })
  }

  render() {
    //
    return (
      <Modal
        isOpen={this.state.modalOpen}
        onRequestClose={this.closeModal}
        shouldCloseOnOverlayClick
        contentLabel='Donate'
        style={{
          overlay : {
            backgroundColor   : 'rgba(0, 0, 0, 0.3)',
            zIndex: 10004,
          },
          content: {
            position                   : 'relative',
            height: '0px',
            left                       : 0,
            right                      : 'auto',
            top                        : 'auto',
            bottom                     : 0,
          //   marginLeft                 : 'auto',
          //   marginRight                : 'auto',
            borderRadius               : 0,
            boxSizing                  : 'border-box',
            width                      : '0px',
            maxWidth                   : '0px',
            border                     : '0px',
            background                 : 'transparent',
            overflow                   : 'visible',
            WebkitOverflowScrolling    : 'touch',
            outline                    : 'none',
          //   transform                  : 'translateY(-50%)',
            padding                    : 0,
          }
        }}
      >
        <div styleName='donate-modal-wrap'>
          <div styleName='donate-modal-wrap-inner'>
            <div styleName='donate-modal'>
              <div styleName='donate-modal-image visible-sm visible-md visible-lg' />
              <div styleName='donate-modal-content'>
                <div styleName='donate-modal-close-wrap'>
                  <span
                    styleName='donate-modal-close'
                    onClick={ this.closeModal }
                  >
                    <LinkIcon faclass='fa-times'/>
                  </span>
                </div>
                <h2 styleName='donate-modal-headline'>
                  Today is #GivingTuesday!
                </h2>
                <p styleName='donate-modal-copy'>
                  Stand up for the right to invest in the future we want
                  to see!
                </p>
                <Link
                  to={config.links.donate}
                  title='Donate today'
                  orangebutton
                >
                  <span styleName='donate-modal-button-text'>Donate today</span>
                </Link>
                <div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

